module.exports = __webpack_public_path__ + "img/menu_button2.c5536313.svg";